import appLogger from "../utils/app-logger";
import { apiService } from "./base-api-service";
import { endPoints, getAssessmentServiceEndPoint } from "./api-constants";
import { readCookie } from "../utils/helpers";

class AssessmentService {
  AssessmentService(url) {
    return getAssessmentServiceEndPoint(url);
  }
  //START REGION :: ASSESSMENT RELATED
  getBulkQuestion(id, languageCode) {
    appLogger.log("inside questionBulkMap ");
    let questionBulkMapEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.QUESTION_BULK_MAP.replace(
        ":assessmentid",
        id
      )}`
    );
    if (languageCode) {
      questionBulkMapEndpoint =
        questionBulkMapEndpoint + `?locale=${languageCode}`;
    }

    return apiService.get(questionBulkMapEndpoint);
  }

  //START REGION :: ASSESSMENT RELATED
  getOneQuestionPerAssessment(assesmentIds, languageCode) {
    appLogger.log("inside questionBulkMap ");
    let getOneQuestionPerAssessmentEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ONE_QUESTION_PER_ASSESSMENT}`
    );
    if (languageCode) {
      getOneQuestionPerAssessmentEndpoint =
        getOneQuestionPerAssessmentEndpoint + `?locale=${languageCode}`;
    }
    return apiService.post(getOneQuestionPerAssessmentEndpoint, assesmentIds);
  }

  getCareerContent(personalityId) {
    // Correctly replace the placeholder with the actual personalityId
    const careerContentEndpoint = this.AssessmentService(
      endPoints.assessmentService.CAREER_CONTENT.replace(
        "{personalityId}",
        personalityId
      )
    ); // Log the constructed endpoint for debugging

    return apiService.get(careerContentEndpoint);
  }

  createUserAnswer(data) {
    appLogger.log("inside createUserAnswer");
    const createUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_USER_ANSWER}`
    );
    return apiService.post(createUserAnswerEndpoint, data);
  }

  updateUserAnswer(data) {
    appLogger.log("inside updateUserAnswer");
    const updateUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_ANSWER}`
    );
    return apiService.put(updateUserAnswerEndpoint, data);
  }

  getUserAnswerByAssessmentAttemptIdAndQuestionId(
    assessmentAttemptId,
    questionId
  ) {
    appLogger.log("inside getUserAnswerByAssessmentAttemptIdAndQuestionId");
    const getUserAnswerByAssessmentAttemptIdAndQuestionIdEndpoint =
      this.AssessmentService(
        `${endPoints.assessmentService.GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID_QUESTIONID}`
          .replace("{assessmentAttemptId}", assessmentAttemptId)
          .replace("{questionId}", questionId)
      );
    return apiService.get(
      getUserAnswerByAssessmentAttemptIdAndQuestionIdEndpoint
    );
  }

  getUserAnswerByAssessmentAttemptId(assessmentAttemptId) {
    appLogger.log("inside getUserAnswerByAssessmentAttemptIdAndQuestionId");
    const getUserAnswerByAssessmentAttemptId = this.AssessmentService(
      `${endPoints.assessmentService.GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID}`.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId
      )
    );
    return apiService.get(getUserAnswerByAssessmentAttemptId);
  }

  saveAssessmentResult(assessmentAttemptId) {
    appLogger.log("inside saveAssessmentResult");
    const saveAssessmentResultEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.SAVE_ASSESSMENT_RESULT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId
      )}`
    );
    return apiService.post(saveAssessmentResultEndpoint, assessmentAttemptId);
  }

  getAssessmentResultByAssessmentAttemptId(assessmentAttemptId, languageCode) {
    appLogger.log("inside getAssessmentAttemptByAssessmentId");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let getAssessmentResulttByAssessmentAttemptIdEndpoint =
      this.AssessmentService(
        `${endPoints.assessmentService.GET_ASSESSMENT_RESULT}`.replace(
          "{assessmentAttemptId}",
          assessmentAttemptId
        )
      );
    if (languageCode) {
      getAssessmentResulttByAssessmentAttemptIdEndpoint =
        getAssessmentResulttByAssessmentAttemptIdEndpoint +
        "?locale=" +
        languageCode;
    }

    return apiService.get(
      getAssessmentResulttByAssessmentAttemptIdEndpoint,
      null,
      headers
    );
  }

  getAssessmentAttempt(assessmentId, userGuid, assessmentAttemptId) {
    appLogger.log("inside assessment attempt ");
    const assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ASSESSMENT_ATTEMPT.replace(
        "{userGuid}",
        userGuid
      ).replace("{assessmentAttemptId}", assessmentAttemptId)}`
    );
    const data = {
      assessmentId,
      userGuid,
    };
    return apiService.get(assessmentAttemptEndpoint);
  }

  updateUserEmail(data) {
    appLogger.log("update email id");
    const assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_EMAIL}`
    );
    return apiService.patch(assessmentAttemptEndpoint, data);
  }

  getAssessmentAttemptByUserId(userGuid, languageCode) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    appLogger.log("inside assessment attempt ");
    let assessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_ASSESSMENT_ATTEMPT_BY_USERID.replace(
        "{userGuid}",
        userGuid
      )}`
    );
    if (languageCode) {
      assessmentAttemptEndpoint =
        assessmentAttemptEndpoint + "?locale=" + languageCode;
    }

    return apiService.get(assessmentAttemptEndpoint, null, headers);
  }

  getAssessment(languageCode) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    appLogger.log("inside assessment id ");
    let assessment = this.AssessmentService(
      `${endPoints.assessmentService.GET_ALL_ASSESSMENT_}`
    );
    if (languageCode) {
      assessment = assessment + "?locale=" + languageCode;
    }

    return apiService.get(assessment, null, headers);
  }

  createAssessmentAttempt(data) {
    appLogger.log("inside createAssessmentAttempt ");
    const createAssessmentAttemptEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_ASSESSMENT_ATTEMPT
    );

    return apiService.post(createAssessmentAttemptEndpoint, data);
  }

  updateAssessmentAttempt(data) {
    appLogger.log("inside updateAssessmentAttempt ");
    const updateAssessmentAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_ASSESSMENT_ATTEMPT}`
    );
    return apiService.put(updateAssessmentAttemptEndpoint, data);
  }

  downloadAssessmentResult(userGUID, assessmentAttemptId, languageCode) {
    let downloadAssessmentEndpoint = this.AssessmentService(
      endPoints.assessmentService.DOWNLOAD_ASSESSMENT_RESULT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId
      ).replace("{userGuid}", userGUID)
    );
    if (languageCode) {
      downloadAssessmentEndpoint =
        downloadAssessmentEndpoint + `?locale=${languageCode}`;
    }

    return apiService.get(downloadAssessmentEndpoint);
  }

  viewAssessmentReport(userGUID, assessmentAttemptId, locale) {
    let viewAssessmentReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.VIEW_ASSESSMENT_REPORT.replace(
        "{assessmentAttemptId}",
        assessmentAttemptId
      ).replace("{userGuid}", userGUID)
    );
    if (locale) {
      viewAssessmentReportEndpoint =
        viewAssessmentReportEndpoint + "?locale=" + locale;
    }
    return apiService.get(viewAssessmentReportEndpoint);
  }

  //END REGION :: ASSESSMENT RELATED

  //START REGION :: USER + AUTH RELATED
  createUser(data) {
    appLogger.log("inside createUser ");
    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_USER}`
    );
    return apiService.post(createUserEndpoint, data);
  }

  createExternalUser(data) {
    appLogger.log("inside ExternalCreateUser ");
    const createExternalUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_EXTERNAL_USER}`
    );
    return apiService.post(createExternalUserEndpoint, data);
  }

  AuthenticateUser(data) {
    appLogger.log("inside AuthenticateUser ");
    const authEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.USER_AUTH}`
    );
    return apiService.post(authEndpoint, data);
  }

  loginAsAdmin(data) {
    appLogger.log("inside loginAsAdmin ");
    const loginAsAdminEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.LOGIN_AS_ADMIN}`
    );
    return apiService.post(loginAsAdminEndpoint, data);
  }

  AuthenticateExternalUser(data) {
    appLogger.log("inside AuthenticateUser ");
    const authEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.EXTERNAL_USER_AUTH}`
    );
    return apiService.post(authEndpoint, data);
  }

  loginUser(Username) {
    const loginEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.USER_LOGIN}`
    );
    const encodedUserName = encodeURIComponent(Username);
    return apiService.get(
      `${loginEndpoint}?username=${encodedUserName}&email=${encodedUserName}`
    );
  }

  searchUserByEmailAndAccountNumber(data) {
    const loginEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.SEARCH_USER_BY_EMAIL_ACCOUNT_NUMBER}`
    );
    const encodedUserName = encodeURIComponent(data.email);
    if (data.accountNumber) {
      // If accountNumber is provided, construct the URL with it
      return apiService.get(
        `${loginEndpoint}?accountNumber=${data.accountNumber}`
      );
    } else if (data.email) {
      // If email is provided, construct the URL with it
      return apiService.get(`${loginEndpoint}?email=${encodedUserName}`);
    } else {
      // Handle the case where neither accountNumber nor email is provided
      console.error("Either accountNumber or email is required.");
      return null; // or throw new Error("Either accountNumber or email is required.");
    }
  }

  updateUserId(data) {
    const updateUserIdInUserAnswerEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USERID}`
    );

    return apiService.put(updateUserIdInUserAnswerEndpoint, data);
  }

  getUserById(userGuid) {
    appLogger.log("inside getUserById ");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };

    // Replace ":userid" with the actual userGUID in the endpoint
    const userEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_BY_ID.replace("{userid}", userGuid)
    );

    return apiService.get(userEndPoint, null, headers);
  }

  forgotPassword(data) {
    appLogger.log("inside forgotPassword ");
    const forgotPasswordEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.FORGOT_PASSWORD}`
    );
    return apiService.patch(forgotPasswordEndpoint, data);
  }

  resetPassword(data) {
    appLogger.log("inside resetPassword ");
    const resetPasswordEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.RESET_PASSWORD}`
    );
    return apiService.post(resetPasswordEndpoint, data);
  }

  changePassword(data) {
    const changePasswordEndPoint = this.AssessmentService(
      endPoints.assessmentService.CHANGE_PASSWORD
    );
    return apiService.post(changePasswordEndPoint, data);
  }

  updateUser(data) {
    const updateUserEndpoint = this.AssessmentService(
      endPoints.assessmentService.UPDATE_USER
    );
    return apiService.put(updateUserEndpoint, data);
  }

  isAdminUser(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const updateUserEndpoint = this.AssessmentService(
      endPoints.assessmentService.IS_ADMIN
    );
    return apiService.post(updateUserEndpoint, data, headers);
  }

  //END REGION :: USER + AUTH RELATED

  //START REGION : PAYMENT RELATED

  getPlans(data) {
    appLogger.log("inside createPayment ");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const getPlansEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.GET_PLANS}`
    );
    return apiService.post(getPlansEndpoint, data, headers);
  }

  createPaymentIntent(data) {
    appLogger.log("inside createPaymentIntent ");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_PAYMENT_INTENT}`
    );
    return apiService.post(createUserEndpoint, data, headers);
  }

  createWalletPaymentIntent(data) {
    appLogger.log("inside createWalletPaymentIntent ");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const createUserEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.CREATE_WALLET_PAYMENT_INTENT}`
    );
    return apiService.post(createUserEndpoint, data, headers);
  }

  doCheckout(data) {
    appLogger.log("inside doCheckout ");
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let createPaymentEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.DO_CHECKOUT}`
    );
    if (data?.locale) {
      createPaymentEndpoint = createPaymentEndpoint + "?locale=" + data?.locale;
    }

    return apiService.post(createPaymentEndpoint, data, headers);
  }

  updateConfirmation(data) {
    const { userGuid } = data;
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    appLogger.log("inside confirmation");
    const confirmationEndPoint = this.AssessmentService(
      endPoints.assessmentService.CONFIRMATION.replace("{userGuid}", userGuid)
    );

    return apiService.put(confirmationEndPoint, data, headers);
  }

  accountCancellation(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let accountCancellationEndPoint = this.AssessmentService(
      endPoints.assessmentService.ACCOUNT_CANCELLATION.replace(
        "{userGuid}",
        data?.userGuid
      )
    );
    if (data?.locale) {
      accountCancellationEndPoint =
        accountCancellationEndPoint + `?locale=${data?.locale}`;
    }

    return apiService.put(accountCancellationEndPoint, data, headers);
  }

  getTransactionDetail(userGuid) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const getTransactionDetailEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_TRANSACTION_DETAILS.replace(
        "{userguid}",
        userGuid
      )
    );
    return apiService.get(getTransactionDetailEndPoint, null, headers);
  }

  getBilling(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const { transId, skuGuid, locale } = data;
    const getBillingEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_BILLING.replace("{transId}", transId)
        .replace("{skuGuid}", skuGuid)
        .replace("{locale}", locale)
    );
    return apiService.get(getBillingEndPoint, null, headers);
  }

  getGuestUser(parentGuid) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const getGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.GET_GUEST_USER.replace(
        "{parentGuid}",
        parentGuid
      )
    );
    return apiService.get(getGuestUserEndPoint, null, headers);
  }

  createGuestUser(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const createGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_GUEST_USER
    );
    return apiService.post(createGuestUserEndPoint, data, headers);
  }

  updateGuestUser(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const updateGuestUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.UPDATE_GUEST_USER
    );
    return apiService.put(updateGuestUserEndPoint, data, headers);
  }

  getPaymentProcessors() {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const paymentProcessorEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_PAYMENT_PROCESSOR_LIST
    );
    return apiService.get(paymentProcessorEndpoint, null, headers);
  }

  updatePaymentProcessorDetails(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const updatePaymentProcessor = this.AssessmentService(
      endPoints.assessmentService.UPDATE_PAYMENT_PROCESSOR
    );
    return apiService.put(updatePaymentProcessor, data, headers);
  }

  decryptURL(token) {
    const decryptURLEndPoint = this.AssessmentService(
      endPoints.assessmentService.DECRYPTURL.replace("{token}", token)
    );
    return apiService.post(decryptURLEndPoint, token);
  }

  isGuestOrPremiumUser(userGuid) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const isGuestOrPremiumUserEndPoint = this.AssessmentService(
      endPoints.assessmentService.IS_GUEST_OR_PREMIUM_USER.replace(
        "{userGuid}",
        userGuid
      )
    );
    return apiService.get(isGuestOrPremiumUserEndPoint, null, headers);
  }

  getContentLatestVersion(data) {
    const { modelType, contentKey } = data;

    const getLatestVersionEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_LATEST_VERSION.replace(
        "{modelType}",
        modelType
      ).replace("{contentKey}", contentKey)
    );
    return apiService.get(getLatestVersionEndpoint);
  }

  getAssessmentByAssessmentId(id) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_ASSESSMENT_BY_ASSESSMENTID.replace(
        "{assessmentId}",
        id
      )
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  createContentMap(data) {
    const createContentMapEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_CONTENT_MAP.replace(
        "{userguid}",
        data.userGuid
      )
    );
    return apiService.post(createContentMapEndpoint, data);
  }

  shareReportOnEmail(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let shareReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.SHARE_REPORT_ON_EMAIL.replace(
        "{userid}",
        data.userGuid
      ).replace("{assessmentAttemptId}", data.assessmentAttemptId)
    );

    if (data?.locale) {
      shareReportEndpoint = shareReportEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(shareReportEndpoint, data, headers);
  }

  deleteReport(data) {
    const headers = { Authorization: `Bearer ${readCookie("jwtToken")}` };
    const deleteReportEndpoint = this.AssessmentService(
      endPoints.assessmentService.DELETE_REPORT
    );
    return apiService.delete(deleteReportEndpoint, data, headers);
  }

  getInsightfulContent(data) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_INSIGHTFUL_CONTENT.replace(
        "{modelType}",
        data.modelType
      ).replace("{contentKey}", data.contentKey)
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  getAbTest(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const abTestEndpoint = this.AssessmentService(
      endPoints.assessmentService.AB_TEST
    );
    return apiService.post(abTestEndpoint, data, headers);
  }

  sendToFriendReportOnEmail(data) {
    const { selfUserId } = data;
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let sendToFriendReportOnEmailEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_TO_FRIEND.replace(
        "{userGuid}",
        selfUserId
      )
    );
    if (data?.locale) {
      sendToFriendReportOnEmailEndpoint =
        sendToFriendReportOnEmailEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(sendToFriendReportOnEmailEndpoint, data, headers);
  }

  sendToPartnerReportOnEmail(data) {
    const { selfUserId } = data;
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    let sendToPartnerReportOnEmailEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_TO_PARTNER.replace(
        "{userGuid}",
        selfUserId
      )
    );
    if (data?.locale) {
      sendToPartnerReportOnEmailEndpoint =
        sendToPartnerReportOnEmailEndpoint + `?locale=${data?.locale}`;
    }
    return apiService.post(sendToPartnerReportOnEmailEndpoint, data, headers);
  }

  sendRefundRequest(userGuid) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const sendRefundRequestEndpoint = this.AssessmentService(
      endPoints.assessmentService.SEND_REFUND_REQUEST.replace(
        "{userGuid}",
        userGuid
      )
    );
    return apiService.post(sendRefundRequestEndpoint, userGuid, headers);
  }

  accountReActivate(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const accountReActivateEndpoint = this.AssessmentService(
      endPoints.assessmentService.ACCOUNT_REACTIVATE
    );
    return apiService.put(accountReActivateEndpoint, data, headers);
  }

  userMetaDetails(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const userMetaDetailsEndpoint = this.AssessmentService(
      endPoints.assessmentService.USER_META
    );
    return apiService.post(userMetaDetailsEndpoint, data, headers);
  }

  bulkReactivate(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const accountReActivateEndpoint = this.AssessmentService(
      endPoints.assessmentService.BULK_ACCOUNT_REACTIVATE
    );
    return apiService.post(accountReActivateEndpoint, data, headers);
  }

  createAssessmentMap(data) {
    appLogger.log("inside createAssessmentAttempt ");
    const createAssessmentMapEndpoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_ASSESSMENT_MAP
    );

    return apiService.post(createAssessmentMapEndpoint, data);
  }

  isCompleteRomanticCompatibility(assessmentMapId) {
    appLogger.log("inside isCompleteRomanticCompatibility ");
    const isCompleteRomanticCompatibilityEndpoint = this.AssessmentService(
      endPoints.assessmentService.IS_COMPLETE_ROMANTIC_COMPATIBILITY.replace(
        "{assessmentMapId}",
        assessmentMapId
      )
    );

    return apiService.get(isCompleteRomanticCompatibilityEndpoint);
  }

  createGuestUserWithoutEmail(data) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const createGuestUserWithoutEmailEndPoint = this.AssessmentService(
      endPoints.assessmentService.CREATE_GUEST_USER_WITHOUT_EMAIL
    );
    return apiService.post(createGuestUserWithoutEmailEndPoint, data, headers);
  }

  saveRelationshipCompatibilityResult(assessmentMapId) {
    appLogger.log("inside saveRelationshipCompatibilityResult ");
    const saveRelationshipCompatibilityResultEndpoint = this.AssessmentService(
      endPoints.assessmentService.SAVE_RELATIONSHIP_COMPATIBILITY_RESULTS.replace(
        "{assessmentMapId}",
        assessmentMapId
      )
    );
    return apiService.post(
      saveRelationshipCompatibilityResultEndpoint,
      assessmentMapId
    );
  }

  saveUserAssessmentResultMaps(data) {
    appLogger.log("inside saveUserAssessmentResultMap ");
    const saveUserAssessmentResultMapsEndpoint = this.AssessmentService(
      endPoints.assessmentService.USER_ASSESSMENT_RESULT_MAP
    );
    return apiService.post(saveUserAssessmentResultMapsEndpoint, data);
  }

  getUserAssessmentResultMapByUserId(userId) {
    const getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_ASSESSMENT_RESULT_MAP.replace(
        "{userId}",
        userId
      )
    );
    return apiService.get(getAssessmentByIdEndpoint);
  }

  getUserAssessmentResultByResultId(id, locale) {
    let getAssessmentByIdEndpoint = this.AssessmentService(
      endPoints.assessmentService.GET_USER_ASSESSMENT_RESULT_BY_RESULT_ID.replace(
        "{id}",
        id
      )
    );
    if (locale) {
      getAssessmentByIdEndpoint =
        getAssessmentByIdEndpoint + `?locale=${locale}`;
    }
    return apiService.get(getAssessmentByIdEndpoint);
  }

  updateUserPassword(data) {
    appLogger.log("update password");
    const userPasswordUpdateEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.UPDATE_USER_PASSWORD}`
    );
    return apiService.patch(userPasswordUpdateEndpoint, data);
  }

  verifyCapchaToken(data) {
    appLogger.log("inside verify capcha token ");
    const requestData = {
      greToken: data?.greToken,
    };
    const verifyCapchaTokenEndpoint = this.AssessmentService(
      endPoints.assessmentService.VERIFY_CAPCHA_TOKER.replace(
        "{portal}",
        data.portal
      )
    );
    return apiService.post(verifyCapchaTokenEndpoint, requestData);
  }

  loginAttempt(data) {
    appLogger.log("inside loginAttempt ");
    const loginAttemptEndpoint = this.AssessmentService(
      `${endPoints.assessmentService.LOGIN_ATTEMPT}`
    );
    return apiService.post(loginAttemptEndpoint, data);
  }

  // updateEmail(userId) {
  //   const updateEmailEndpoint = this.AssessmentService(endPoints.assessmentService.UPDATE_USER_EMAIL);
  //   return apiService.put(updateEmailEndpoint, userId);
  // }

  //END REGION
}

export default new AssessmentService();
